
<template>
  <div class="os-grid p-grid">
    <slot></slot>
  </div>
</template>

<script>

export default {
}

</script>
